import * as types from 'actions/types';
import dotProp from 'dot-prop-immutable';

const INITIAL_STATE = {
  showSpecialistTools: true,
  expertDashboardOpened: false,
  debugModeEnabled: false,
};

const userSettings = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_SHOW_SPECIALIST_TOOLS:
      return dotProp.set(state, 'showSpecialistTools', action.value);
    case types.SET_EXPERT_DASHBOARD_OPENED:
      return dotProp.set(state, 'expertDashboardOpened', action.value);
    case types.SET_DEBUG_MODE:
      return dotProp.set(state, 'debugModeEnabled', action.value);
    default:
      return state;
  }
};

export default userSettings;
